import { useAppDispatch } from "../../store/hooks";
import { useEffect } from 'react';
import { authParamsSlice } from "../../store/slices/authParams";
import { setCallback } from "../../utils/callbacks";
export function useSetProps(props) {
  var dispatch = useAppDispatch();
  useEffect(function () {
    dispatch(authParamsSlice.actions.setParams(props.authParams));
  }, [dispatch, props.authParams]);
  useEffect(function () {
    if (props.onClose) {
      setCallback('onClose', props.onClose);
    }
    if (props.onError) {
      setCallback('onError', props.onError);
    }
    if (props.onSuccess) {
      setCallback('onSuccess', props.onSuccess);
    }
    if (props.onLoading) {
      setCallback('onLoading', props.onLoading);
    }
  }, [props.onClose, props.onError, props.onSuccess, props.onLoading]);
}